import axios from 'axios'

export default {
  async generateExplanation(payload) {
    return axios.post(`/openai/generate-explanation`, payload)
  }
}
